import * as types from './types';
import { apiGetRoms } from './api';
import { RomListSearchCriteria } from './interfaces';

export const setSearchCriteriaValue = (name, value) => ({ type: types.ROM_LIST__SET_SEARCH_CRITERIA_VALUE, name, value });

export const setRomList = roms => ({ type: types.ROM_LIST__SET_ROM_LIST, roms });

export const getRoms = (criteria: RomListSearchCriteria) => (dispatch) => {
    return apiGetRoms(criteria).then((results) => {
        dispatch(setRomList(results.roms));
    });
};

export const clearSearchCriteria = () => ({ type: types.ROM_LIST__CLEAR_SEARCH_CRITERIA });
